import HomeOutlined from '@ant-design/icons/HomeOutlined';
import Tag from 'antd/lib/tag';
import Tooltip from 'antd/lib/tooltip';
import Typography from 'antd/lib/typography';
import React, { useMemo } from 'react';
import { ICustomerVen } from '../../domain/ven/interface';

export interface ICustomerVenScopeInfoProps {
    customerVen: ICustomerVen;
}

export const CustomerVenScopeInfo: React.FC<ICustomerVenScopeInfoProps> = ({ customerVen }) => {
    const { companyName, scopeLabel, scopeColor, title } = useMemo(() => {
        const companyName = customerVen.company?.company_name ?? 'N/A';
        let scopeLabel = 'All Sites';
        let scopeColor = 'default';

        if (customerVen.site) {
            scopeLabel = `Site: ${customerVen.site.site_name}`;
            scopeColor = 'blue';
        } else if (customerVen.control_provider_id) {
            const cpName = customerVen?.control_provider?.company_name ?? 'N/A';
            scopeLabel = `CP: ${cpName}`;
            scopeColor = 'purple';
        }

        const title = scopeLabel ? `${companyName} / ${scopeLabel}` : companyName;

        return {
            companyName,
            scopeLabel,
            scopeColor,
            title,
        };
    }, [customerVen]);

    return (
        <Tooltip title={title} placement="topLeft">
            <Typography className="ellipsis">
                <Tag color="default" style={{ display: 'initial', position: 'static' }} icon={<HomeOutlined />}>
                    {companyName}
                </Tag>
                {scopeLabel && (
                    <Tag color={scopeColor} style={{ display: 'initial', position: 'static', marginTop: 2 }}>
                        {scopeLabel}
                    </Tag>
                )}
            </Typography>
        </Tooltip>
    );
};
